import { type FieldError } from 'react-hook-form';

export const getFormErrorAttributes = (error?: FieldError) => {
  return {
    error: !!error,
    'aria-invalid': !!error,
  };
};
